import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';
import { openConsentBanner } from '@/lib/analytics';

export default function Footer() {
  const { t } = useTranslation();
  const location = useLocation();
  const [time, setTime] = useState('');

  useEffect(() => {
    const update = () => setTime(new Date().toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit', second: '2-digit', timeZone: 'Europe/Berlin' }));
    update();
    const id = setInterval(update, 1000);
    return () => clearInterval(id);
  }, []);

  const scrollOnStudio = (e, targetId) => {
    if (location.pathname !== '/studio') return;
    e.preventDefault();
    if (targetId === null) {
      if (window.__lenis) window.__lenis.scrollTo(0);
      else window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    const el = document.getElementById(targetId);
    if (!el) return;
    if (window.__lenis) window.__lenis.scrollTo(el, { offset: -96 });
    else el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-ink pt-32 pb-8 px-6 md:px-12 lg:px-24" data-testid="footer">
      <div className="mb-24 overflow-hidden">
        <h2 className="font-display font-bold text-cream tracking-tighter leading-[0.85]" style={{ fontSize: 'clamp(3rem, 10vw, 10rem)' }}>
          EB AGENCY
        </h2>
      </div>

      <div className="flex flex-col md:flex-row gap-16 md:gap-32 mb-24">
        <div>
          <h4 className="text-xs uppercase tracking-[0.25em] text-gold mb-6 font-body font-semibold">{t('footer.studio')}</h4>
          <div className="flex flex-col gap-3">
            <Link to="/studio" onClick={(e) => scrollOnStudio(e, null)} className="text-cream-muted hover:text-cream transition-colors text-sm font-body" data-testid="footer-about">{t('footer.about')}</Link>
            <Link to="/studio#process" onClick={(e) => scrollOnStudio(e, 'process')} className="text-cream-muted hover:text-cream transition-colors text-sm font-body" data-testid="footer-process">{t('footer.process')}</Link>
            <Link to="/contact" className="text-cream-muted hover:text-cream transition-colors text-sm font-body" data-testid="footer-contact">{t('footer.contact')}</Link>
          </div>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.25em] text-gold mb-6 font-body font-semibold">{t('footer.legal')}</h4>
          <div className="flex flex-col gap-3">
            <Link to="/legal/imprint" className="text-cream-muted hover:text-cream transition-colors text-sm font-body" data-testid="footer-imprint">{t('footer.imprint')}</Link>
            <Link to="/legal/privacy" className="text-cream-muted hover:text-cream transition-colors text-sm font-body" data-testid="footer-privacy">{t('footer.privacy')}</Link>
            <button
              type="button"
              onClick={openConsentBanner}
              className="text-cream-muted hover:text-cream transition-colors text-sm font-body text-left"
              data-testid="footer-cookie-settings"
            >
              {t('footer.cookieSettings')}
            </button>
          </div>
        </div>
        {/*
          Social column — temporarily hidden until final URLs are confirmed.
          When re-enabling, change the grid above to md:grid-cols-3.
          <div>
            <h4 className="text-xs uppercase tracking-[0.25em] text-gold mb-6 font-body font-semibold">{t('footer.social')}</h4>
            <div className="flex flex-col gap-3">
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-cream-muted hover:text-cream transition-colors text-sm font-body">Instagram</a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-cream-muted hover:text-cream transition-colors text-sm font-body">LinkedIn</a>
              <a href="https://behance.net" target="_blank" rel="noopener noreferrer" className="text-cream-muted hover:text-cream transition-colors text-sm font-body">Behance</a>
            </div>
          </div>
        */}
        
      </div>

      <div className="flex flex-col md:flex-row justify-between items-center pt-8 border-t border-smoke/50">
        <p className="text-xs text-cream-muted font-body">{t('footer.copyright')}</p>
        <span className="text-xs text-cream-muted font-body mt-2 md:mt-0" data-testid="footer-clock">Frankfurt · {time} CET</span>
      </div>
    </footer>
  );
}
